/**
 * all states from store
 */
export default {
  checklists: [],
  show_latter: false,
};
